export default __webpack_public_path__ + "static/media/p_wdt_c_4.e7da7afe.mp3";